<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-close="close" vm-size="medium" @vm-accept="close" :vm-buttons-hidden="true" :vm-accept-text="$t('strings.sendings_receptions')" :vm-is-valid="true" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalReceptionVisible" :vm-title='title')
  vm-tabs
    vm-tab(vm-label='Recepciones')
      vm-row(vm-w="12" vm-type="flex" vm-justify="space-around" class="p-0")
        vm-col(vm-w=12 class="p-0" )
          vm-table(max-height="350px" :data="receptionsDetails" class="table")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('receptions.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column === 'product'") {{ data[indextr][column].name }}
                  slot(v-if="column === 'quantity_ordered'") {{ data[indextr][column] }}
                  slot(v-if="column === 'received_quantity'") {{ data[indextr][column] }}
                  slot(v-if="column === 'created_by'") {{ data[indextr]['user'].name }}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Receptions')

export default {
  name: 'ModalSendingsAndReceptions',
  props: {
    purchase_order_detail_id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    columns: [
      'product',
      'quantity_ordered',
      'received_quantity',
      'created_by'
    ]
  }),
  computed: {
    ...mapGetters(['isModalReceptionVisible', 'receptionsDetails']),
    title () {
      return this.$t('strings.sendings_receptions')
    }
  },
  watch: {
    isModalReceptionVisible (flag) {
      if (flag) {
        this.loadReceptionsByPurchaseOrderDetail({ purchase_order_detail_id: this.purchase_order_detail_id })
      }
    }
  },
  methods: {
    ...mapActions(['setModalReceptionVisible', 'loadReceptionsByPurchaseOrderDetail', 'loadSupplierShipments']),
    close () {
      this.setModalReceptionVisible(false)
    }
  }
}
</script>
